// Shared rendering keeps server HTML and client navigation content identical.
const React = require('react');
const services = require('./aiServices.json');
const servicePages = require('./pages');
const h = React.createElement;
const BASE = '/technologies/artificial-intelligence';
const ORIGIN = 'https://www.blaketechnologies.com';
const groups = ['Plan & enable', 'Build & connect', 'Intelligence in practice', 'Operate & govern'];
const servicePath = service => `${BASE}/${service.slug}`;
const findService = slug => services.find(service => service.slug === slug);
const contact = (label = 'Discuss your AI project') => h('a', { href: '/contact?type=business', className: 'ai-button' }, label, h('span', { 'aria-hidden': true }, ' ↗'));

function serviceMetadata(service) {
  const title = service ? service.metaTitle || `${service.title} | Blake Technologies` : 'AI Development for Businesses & Private Equity | Blake Technologies';
  const description = service ? service.summary : 'AI software development for businesses, service companies, and private equity firms. Explore consulting, automation, integration, and portfolio solutions.';
  const canonical = `${ORIGIN}${service ? servicePath(service) : BASE}`;
  const crumbs = [
    ['Home', '/'], ['Technologies', '/technologies'], ['Artificial Intelligence', BASE],
    ...(service ? [[service.title, servicePath(service)]] : [])
  ];
  return { title, description, canonical, structured: {
    '@context': 'https://schema.org', '@graph': [
      service ? { '@type': 'Service', '@id': `${canonical}#service`, name: service.title, description, url: canonical,
        provider: { '@type': 'Organization', name: 'Blake Technologies', url: ORIGIN } }
      : { '@type': 'CollectionPage', name: title, description, url: canonical,
        mainEntity: { '@type': 'ItemList', itemListElement: services.map((entry, i) => ({ '@type': 'ListItem', position: i + 1, name: entry.title, url: `${ORIGIN}${servicePath(entry)}` })) } },
      { '@type': 'BreadcrumbList', itemListElement: crumbs.map(([name, path], i) => ({ '@type': 'ListItem', position: i + 1, name, item: `${ORIGIN}${path}` })) }
    ]
  } };
}
function cards(entries) {
  return h('div', { className: 'ai-card-grid' }, entries.map(service => h('article', { className: 'ai-service-card', key: service.slug },
    h('h3', null, h('a', { href: servicePath(service) }, service.title, h('span', { 'aria-hidden': true }, ' ↗'))),
    h('p', null, service.summary)
  )));
}
function AIServiceDirectory({ embedded = false }) {
  const prefix = embedded ? 'technology-ai' : 'ai-directory';
  return h('section', { className: 'ai-directory', id: embedded ? 'artificial-intelligence' : 'services', 'aria-labelledby': `${prefix}-title` },
    h('div', { className: 'ai-container' },
      h('div', { className: 'ai-section-heading' },
        h('p', { className: 'ai-eyebrow' }, 'Artificial intelligence · Blake Technologies'),
        h('h2', { id: `${prefix}-title` }, 'Artificial Intelligence'),
        h('p', null, 'AI consulting and custom software development for businesses, service companies, and private equity firms. Explore services for customer operations, back-office automation, and portfolio-company technology initiatives.')
      ),
      h('nav', { className: 'ai-group-links', 'aria-label': 'AI service categories' }, groups.map((group, index) => h('a', { key: group, href: `#${prefix}-${index}` }, group))),
      groups.map((group, index) => h('section', { key: group, id: `${prefix}-${index}`, className: 'ai-category', 'aria-labelledby': `${prefix}-heading-${index}` },
        h('div', { className: 'ai-category-heading' }, h('span', { 'aria-hidden': true }, `0${index + 1}`), h('h3', { id: `${prefix}-heading-${index}` }, group)),
        cards(services.filter(service => service.group === group))
      )),
      h('div', { className: 'ai-directory-footer' }, h('p', null, 'Start with a business question. We’ll help define the right scope, the delivery team, and the evidence needed to move forward.'), contact('Talk through an AI opportunity'))
    )
  );
}
function Breadcrumbs({ service }) {
  return h('nav', { className: 'ai-breadcrumbs', 'aria-label': 'Breadcrumb' },
    h('a', { href: '/technologies' }, 'Technologies'), h('span', { 'aria-hidden': true }, '/'),
    service ? h('a', { href: BASE }, 'Artificial Intelligence') : h('span', { 'aria-current': 'page' }, 'Artificial Intelligence'),
    service && h('span', { 'aria-hidden': true }, '/'), service && h('span', { 'aria-current': 'page' }, service.title)
  );
}
function AIServicePage({ service }) {
  if (!service) return h('main', { className: 'ai-page', id: 'main' },
    h('section', { className: 'ai-hero' }, h('div', { className: 'ai-container' }, h(Breadcrumbs),
      h('p', { className: 'ai-eyebrow' }, 'Enterprise AI services'), h('h1', null, 'Intelligence built into the way you work.'),
      h('p', { className: 'ai-lead' }, 'Blake Technologies is a software development company helping businesses and private equity firms build AI into daily operations. Explore custom applications, service-business automation, and technology solutions for portfolio companies.'), contact())),
    h(AIServiceDirectory)
  );
  const Page = servicePages[service.slug];
  return h(Page, { service });
}
module.exports = { AIServiceDirectory, AIServicePage, serviceMetadata, services, findService, servicePath, BASE, ORIGIN };
